import React, { CSSProperties, useCallback, useEffect, useRef, useState } from 'react';
import { Button, Grid, Modal, Stack, SvgIcon, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router';
import { paths } from 'src/paths';
import { Box } from '@mui/system';
import { getAccessToken } from 'src/routes/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import {
  errorForLoaderDocumentation,
  pullUuidAction,
  requestForLoaderDocumentation,
  resetForLoaderDocumentation,
  resetUuidAction,
  successForLoaderDocumentation,
} from 'src/redux/actions/documentationAction';
import loader from 'src/components/LoaderImg/loader.gif';
import { baseApiUrl, reFormsMdsCommunicationTreatment } from 'src/config';
import { subscribeSubmissionevent } from 'src/services/apiServices/constants';
import SucessModal from 'src/components/sucess-modal';
import ReForm from 'src/components/reform';
import useFeatureToggle from 'src/hooks/use-feature-toggle';
const loaderCSS: CSSProperties = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  userSelect: 'none',
  zIndex: 9999,
};

function AddMdsCommunication() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patientId, patientData, mdsData } = location.state;
  const { patients, patientDetails, mdsCommunication } = paths;
  const mdsFormId = useSelector((state: any) => state.getMdsFormIdReducer);
  const pullUuidResponse = useSelector((state: any) => state.pullUuidRducder);
  const submissionSse = useRef<EventSource | null>(null);
  const isDocLoader = useSelector((state: any) => state.loaderDocumenattionReducer);
  const getMdsReformIdReducer = useSelector((state: any) => state.getMdsReformIdReducer);
  const [reFormsMdsEnabled] = useFeatureToggle(reFormsMdsCommunicationTreatment, 'FACILITY');

  const gotoback = () => {
    dispatch(resetUuidAction());
    dispatch(resetForLoaderDocumentation());
    navigate(`${patients}/${patientDetails}${mdsCommunication}`, {
      state: {
        patientId,
        patientData,
      },
    });
  };

  const getHiddenUuid = () => {
    return `${pullUuidResponse.response?.trim()}X${
      window.location.hostname === 'localhost'
        ? localStorage.getItem('realm')
        : window.location.hostname.split('-')[0]
    }`;
  };

  const [iframeRef, setIframeRef] = useState<any | null>(null);
  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  useEffect(() => {
    if (!patientId) return;
    dispatch(
      pullUuidAction({
        uuid: null,
        patientId,
        entityType: 'MDS',
      })
    );
  }, [patientId]);

  useEffect(() => {
    if (!pullUuidResponse.response || pullUuidResponse.loading) return;
    const createEventSource = () => {
      submissionSse.current = new EventSource(
        `${baseApiUrl}${subscribeSubmissionevent}/${pullUuidResponse.response}`
      );

      submissionSse.current.addEventListener('message', (e) => {
        const eventData = JSON.parse(e.data);
        switch (eventData?.data) {
          case '1':
            dispatch(requestForLoaderDocumentation(eventData?.data));
            break;
          case '2':
            dispatch(successForLoaderDocumentation(eventData?.data));
            break;
          case '3':
            dispatch(errorForLoaderDocumentation(eventData?.error));
            break;
          default:
            break;
        }
      });

      submissionSse.current.addEventListener('error', (e: any) => {
        if (e.eventPhase === 2) {
          if (submissionSse.current) {
            submissionSse.current.close();
          }
          createEventSource();
        }
      });
    };

    createEventSource();

    return () => {
      if (submissionSse.current) {
        submissionSse.current.close();
      }
    };
  }, [pullUuidResponse]);

  const [openErrorModal, setOpenErrorModal] = useState(false);
  const closeErrorModal = () => {
    setOpenErrorModal(false);
    dispatch(resetForLoaderDocumentation());
  };

  useEffect(() => {
    if (!isDocLoader.loader && isDocLoader.response === null) return;
    if (isDocLoader.error) {
      setOpenErrorModal(true);
      return;
    }
    if (!isDocLoader.loader) {
      dispatch(resetForLoaderDocumentation());
      gotoback();
    }
  }, [isDocLoader]);

  const destructureDate = (dateData: string) => {
    if (!dateData) {
      return {
        month: '',
        year: '',
        day: '',
      };
    }
    const date = dateData?.split('-');
    const result = {
      month: date[1],
      year: date[0],
      day: date[2].split('T')[0],
    };

    return result;
  };

  const getCleanUuid = () => {
    return pullUuidResponse?.response?.trim() || '';
  };

  return (
    <>
      {isDocLoader.loader && (
        <Grid sx={loaderCSS}>
          <img
            src={loader}
            alt="loader.."
          />
        </Grid>
      )}

      <Grid
        container
        justifyContent={'space-between'}
      >
        <Stack
          gap="1.5rem"
          sx={{ padding: '0 4rem' }}
        >
          <Button
            sx={{
              justifyContent: 'flex-start',
              color: '#111927',
              width: 'max-content',
              padding: '0px',
            }}
            onClick={gotoback}
            startIcon={
              <SvgIcon>
                <ArrowBackIcon sx={{ color: '#6C737F' }} />
              </SvgIcon>
            }
          >
            <Typography variant="subtitle1">Back to MDS Assessment List</Typography>
          </Button>
          <Stack
            flexDirection="row"
            gap="1rem"
            alignItems="center"
          >
            <Typography variant="h5">Create Document - MDS Assessment</Typography>
          </Stack>
        </Stack>
      </Grid>
      {pullUuidResponse?.loading ? (
        <img
          src={loader}
          alt="loader"
          style={{ width: '10%', margin: 'auto' }}
        />
      ) : (
        <Box
          sx={{ height: '100%' }}
          p={3}
        >
          {!reFormsMdsEnabled ? (
            <iframe
              src={`${mdsFormId?.response?.data?.data
                ?.t1}?patientName[first]=${patientData?.firstName}&patientName[last]=${patientData?.lastName}&mrn=${
                patientData?.medicalRecordNumber || ''
              }&assessmentType=${mdsData.assessmentType}&assessmentDate[month]=${
                destructureDate(mdsData?.assessmentDate).month
              }&assessmentDate[year]=${
                destructureDate(mdsData?.assessmentDate).year
              }&assessmentDate[day]=${
                destructureDate(mdsData?.assessmentDate).day
              }&hiddenUuid=${getHiddenUuid()}`}
              ref={updateIFrameRef}
              width={'100%'}
              height={'100%'}
              title=""
              style={{ border: 'none' }}
            />
          ) : (
            <ReForm
              formId={getMdsReformIdReducer.response?.data?.data}
              uuid={getCleanUuid()}
            />
          )}
        </Box>
      )}

      <Modal open={openErrorModal}>
        <SucessModal
          close={closeErrorModal}
          isSucess={false}
          title="Create a Document"
          message={isDocLoader?.response}
        />
      </Modal>
    </>
  );
}

export default AddMdsCommunication;
